import { useQuery } from "@tanstack/react-query";
import {
  fetchApprovedFolders,
  fetchApprovedSubfolders,
  fetchApprovedFiles,
} from "../services/fetchApprovedFileHierarchy";

/**
 * Hook to fetch top-level approved submission folders.
 */
export function useApprovedFolders(adminId) {
  return useQuery({
    queryKey: ["approvedFolders", adminId],
    queryFn: () => fetchApprovedFolders(adminId),
    enabled: !!adminId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch subfolders for a given adminId and folderId.
 * @param {string} adminId
 * @param {string} folderId
 */
export function useApprovedSubfolders(adminId, folderId) {
  return useQuery({
    queryKey: ["approvedSubfolders", adminId, folderId],
    queryFn: () => fetchApprovedSubfolders(adminId, folderId),
    enabled: !!adminId && !!folderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch files for a given adminId, folderId and subfolderId.
 * @param {string} adminId
 * @param {string} folderId
 * @param {string} subfolderId
 */
export function useApprovedFiles(adminId, folderId, subfolderId) {
  return useQuery({
    queryKey: ["approvedFiles", adminId, folderId, subfolderId],
    queryFn: () => fetchApprovedFiles(adminId, folderId, subfolderId),
    enabled: !!adminId && !!folderId && !!subfolderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
